import { load } from "@cashfreepayments/cashfree-js";

type CashfreeMode = "sandbox" | "production";

const cashfreeInstances: Record<string, ReturnType<typeof load>> = {};

function getCashfree(mode?: string) {
  const effectiveMode = (mode as CashfreeMode) || "sandbox";
  if (!cashfreeInstances[effectiveMode]) {
    cashfreeInstances[effectiveMode] = load({ mode: effectiveMode }).catch((err) => {
      // Clear cache entry on load failure so retries can load the SDK cleanly
      delete cashfreeInstances[effectiveMode];
      throw err;
    });
  }
  return cashfreeInstances[effectiveMode];
}

/**
 * Launch Cashfree checkout for a payment session.
 * @param paymentSessionId - from /checkout response: data.paymentSessionId
 * @param paymentMode - from data.paymentMode ("sandbox" | "production")
 */
export async function startCashfreeCheckout(
  paymentSessionId: string,
  paymentMode?: string,
) {
  if (!paymentSessionId) throw new Error("Missing paymentSessionId");
  const cashfree = await getCashfree(paymentMode);
  // redirectTarget "_self" opens Cashfree's real checkout in the same tab.
  // After payment, Cashfree returns to the order's return_url (backend → /MyOrders).
  return cashfree.checkout({
    paymentSessionId,
    redirectTarget: "_self",
  });
}
